import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceArea,
} from 'recharts'
import moment from 'moment'
import './KeyMetrics.css'

const KeyMetrics = ({ data, selections }) => {
    const [refAreaLeft, setAreaLeft] = useState('')
    const [refAreaRight, setAreaRight] = useState('')
    const [selection, setSelection] = useState(selections[0])
    const location = useLocation()
    const history = useHistory()

    const updateRoute = (startDate, endDate) => {
        const pathname = location.pathname

        const query = {}
        if (startDate) query.startDate = moment(startDate).format('YYYYMMDD')
        if (endDate) query.endDate = moment(endDate).format('YYYYMMDD')

        const querystring = queryString.stringify(query)

        if (querystring) {
            history.push(`${pathname}?${querystring}`)
        } else {
            history.push(pathname)
        }
    }

    const chartData = selection.mapDataForChart(data)

    const zoom = () => {
        if (refAreaLeft === refAreaRight || refAreaRight === '') {
            setAreaLeft('')
            setAreaRight('')
            return
        }

        const leftArea = moment(refAreaLeft)
        const rightArea = moment(refAreaRight)

        if (leftArea.isSameOrBefore(rightArea)) {
            updateRoute(refAreaLeft, refAreaRight)
            return
        }
        updateRoute(refAreaRight, refAreaLeft)
    }

    return (
        <div className="key-metrics">
            <div className="key-metrics-items">
                {selections.map(s => (
                    <div
                        key={s.label}
                        onClick={() => setSelection(s)}
                        className={`key-metric-item ${
                            selection.label === s.label ? 'active' : undefined
                        }`}
                    >
                        <div className="key-title">{s.label}</div>
                        {s.renderTab(data)}
                    </div>
                ))}
            </div>
            <div
                className="key-metric-chart disable-click-md"
                style={{ userSelect: 'none' }}
            >
                <ResponsiveContainer width="100%" height={250}>
                    <AreaChart
                        data={chartData}
                        fontSize={12}
                        fontFamily={'Open Sans'}
                        onMouseDown={e => {
                            if (e && e.activeLabel) {
                                setAreaLeft(e.activeLabel)
                            }
                        }}
                        onMouseMove={e => {
                            if (refAreaLeft && e && e.activeLabel) {
                                setAreaRight(e.activeLabel)
                            }
                        }}
                        onMouseUp={zoom}
                        margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <defs>
                            <pattern
                                id="circles-1"
                                patternUnits="userSpaceOnUse"
                                width="35"
                                height="35"
                            >
                                <rect width="35" height="35" fill="#85b4d4" />
                                <g transform="rotate(45)">
                                    <rect
                                        width="49"
                                        height="12"
                                        fill="#4790c1"
                                    />
                                    <rect
                                        y="-25"
                                        width="49"
                                        height="12"
                                        fill="#4790c1"
                                    />
                                </g>
                            </pattern>
                            <pattern id="points" height="20" width="20">
                                <circle
                                    cx="10"
                                    cy="10"
                                    r="20"
                                    fill="white"
                                    strokeWidth="2"
                                    stroke="black"
                                />
                            </pattern>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            padding={{ left: 20, right: 20 }}
                            dataKey="x"
                            tickFormatter={timeStr =>
                                moment(timeStr).format('DD MMM')
                            }
                        />
                        <YAxis tickFormatter={selection.tickFormatter} />
                        <Tooltip content={selection.tooltip} />
                        <Area
                            type="monotone"
                            dataKey="y"
                            stroke="#4790c1"
                            strokeWidth="2"
                            fill="url(#circles-1)"
                            fillOpacity="0.1"
                        />

                        {refAreaLeft && refAreaRight ? (
                            <ReferenceArea
                                x1={refAreaLeft}
                                x2={refAreaRight}
                                strokeOpacity={0.3}
                            />
                        ) : null}
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}
export default KeyMetrics
